import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { filter, mergeMap } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import { PublishReleaseError, PublishReleaseSuccess } from '../action-creators';
import { UpdateArtistsPlatformsSuccess } from '../../artist/action-creators';
import { UPDATE_ARTISTS_PLATFORMS_SUCCESS } from '../../artist/actions';
import { NoOp } from '../../ui/action-creators';

export const regenerateAfterRepaitEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, UpdateArtistsPlatformsSuccess>(
      UPDATE_ARTISTS_PLATFORMS_SUCCESS
    ),
    filter((action) => !!(action.releaseId && action.ownerId)),
    mergeMap(async (action) => {
      if (!action.releaseId || !action.ownerId) {
        return new NoOp();
      }

      try {
        await release.regenerate(action.ownerId, action.releaseId);

        return new PublishReleaseSuccess(action.ownerId, action.releaseId, []);
      } catch (err) {
        return new PublishReleaseError(err.message);
      }
    })
  );
